import request from '@/utils/request'


// 查询工资模板列表
export function listSalary(query) {
  return request({
    url: '/user/salary-detail/list',
    method: 'get',
    params: query
  })
}

// 查询工资模板分页
export function pageSalary(query) {
  return request({
    url: '/user/salary-detail/page',
    method: 'get',
    params: query
  })
}

// 查询工资模板详细
export function getSalary(data) {
  return request({
    url: '/user/salary-detail/detail',
    method: 'get',
    params: data
  })
}

// 新增工资模板
export function addSalary(data) {
  return request({
    url: '/user/salary-detail/add',
    method: 'post',
    data: data
  })
}

// 修改工资模板
export function updateSalary(data) {
  return request({
    url: '/user/salary-detail/edit',
    method: 'post',
    data: data
  })
}

// 删除工资模板
export function delSalary(data) {
  return request({
    url: '/user/salary-detail/delete',
    method: 'post',
    data: data
  })
}
